import clsx from "clsx";
import { FieldError } from "react-hook-form";

export type FormInputMessageProps = {
    id?: string;
    error?: FieldError | string;
    helpText?: string;
    className?: string;
};

const FormInputMessage = ({
    id,
    error,
    helpText,
    className,
}: FormInputMessageProps) => {
    const commonClassNames = clsx("text-xs ml-4 block mt-2", className);

    if (error) {
        return (
            <span
                className={clsx(commonClassNames, "text-red-40")}
                aria-describedby={id}
            >
                {typeof error === "string" ? error : error?.message}
            </span>
        );
    }

    if (helpText) {
        // We set aria-hidden to true to hide this from screen readers, as the help text is applied to
        // the input control itself using aria-describedby to provide instructions re formatting etc
        return (
            <span className={clsx(commonClassNames, "")} aria-hidden="true">
                {helpText}
            </span>
        );
    }

    return null;
};

export default FormInputMessage;
